import { render, staticRenderFns } from "./FeeReminder.vue?vue&type=template&id=6b02acfc&"
import script from "./FeeReminder.vue?vue&type=script&lang=js&"
export * from "./FeeReminder.vue?vue&type=script&lang=js&"
import style0 from "./FeeReminder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports